(function(){
  'use strict';
  const widgets=[...document.querySelectorAll('[data-baf-rewards]')];
  if(!widgets.length)return;
  const config=widgets[0].dataset;
  const root=config.root.replace(/\/?$/,'/');
  const shippingGoal=Number(config.shipping);
  const cookbookGoal=Number(config.cookbook);
  const progressGoal=Math.max(shippingGoal,cookbookGoal);
  if(!Number.isFinite(shippingGoal)||shippingGoal<=0||!Number.isFinite(cookbookGoal)||cookbookGoal<=0)return;
  let timer,requestVersion=0;
  const money=n=>new Intl.NumberFormat(undefined,{style:'currency',currency:window.Shopify?.currency?.active||'USD'}).format(n/100);
  function render(cart){
    const subtotal=Number(cart.total_price);
    if(!Number.isFinite(subtotal))return;
    const shippingEarned=subtotal>=shippingGoal;
    const cookbookEarned=subtotal>=cookbookGoal;
    let message;
    if(cookbookEarned&&shippingEarned){
      message="Congratulations! You've unlocked your free cookbook and free shipping!";
    }else if(cookbookEarned){
      message="Free cookbook unlocked! You're "+money(shippingGoal-subtotal)+" away from free shipping!";
    }else if(shippingEarned){
      message="Free shipping unlocked! You're "+money(cookbookGoal-subtotal)+" away from a free cookbook!";
    }else{
      message="You're "+money(cookbookGoal-subtotal)+" away from a free cookbook!";
    }
    for(const w of widgets){
      w.querySelector('[data-reward-fill]').style.width=Math.min(100,Math.max(0,subtotal/progressGoal*100))+'%';
      w.querySelector('[role=progressbar]').setAttribute('aria-valuenow',String(Math.min(progressGoal,Math.max(0,subtotal))/100));
      w.querySelector('[data-cookbook-label]').classList.toggle('is-earned',cookbookEarned);
      w.querySelector('[data-shipping-label]').classList.toggle('is-earned',shippingEarned);
      w.querySelector('[data-reward-message]').textContent=message;
    }
  }
  async function refresh(){
    const version=++requestVersion;
    try{
      const response=await fetch(root+'cart.js',{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
      if(!response.ok)throw new Error('Cart refresh failed.');
      const cart=await response.json();
      if(version===requestVersion)render(cart);
    }catch(e){
      if(version===requestVersion)widgets.forEach(w=>{
        w.querySelector('[data-reward-message]').textContent='Free digital cookbook on qualifying '+money(cookbookGoal)+'+ orders and free shipping on qualifying '+money(shippingGoal)+'+ orders, after discounts.';
      });
    }
  }
  function schedule(){clearTimeout(timer);timer=setTimeout(refresh,250);}
  ['ajaxProduct:added','cart:updated','cart:build','cart:change','cart:add','drawerOpen','baf:rewards-updated'].forEach(name=>document.addEventListener(name,schedule));
  document.addEventListener('change',e=>{if(e.target.closest('#CartDrawer,#CartPageForm'))schedule();});
  document.querySelectorAll('#CartDrawer [data-products],#CartPageForm [data-products]').forEach(container=>new MutationObserver(schedule).observe(container,{childList:true,subtree:true}));
  refresh();
})();
